import { Component, OnInit, ViewChild } from '@angular/core';
import { Course, corsi } from '../models/corsi';
import { Router } from '@angular/router';
import { animate, style, transition, trigger } from '@angular/animations';
import { NgbDropdown, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { GenericFormComponent } from '../generic-form/generic-form.component';
import { MatMenuTrigger } from '@angular/material/menu';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss'],
  animations: [
    trigger('slidein', [
      transition(':enter', [
        // when ngif has true
        style({ transform: 'translateX(-100%)' }),
        animate(250, style({ transform: 'translateX(0)' })),
      ]),
      transition(':leave', [
        // when ngIf has false
        animate(250, style({ transform: 'translateX(-100%)' })),
      ]),
    ]),
  ],
})
export class HeaderComponent implements OnInit {
  listaCorsi = corsi;
  corsiOpen = false;
  menuOpen = false;
  public isCollapsed = true;
  public expanded = false;
  public toggleIcon = true;
  constructor(private router: Router, private modalService: NgbModal) {}


  ngOnInit(): void {}

  isActive(path: string): boolean {
    return this.router.url === path;
  }

  openCourse(corso: Course) {
    this.router.navigateByUrl('/corsi/' + corso.path);
  }

  toggleCorsi() {
    this.corsiOpen = !this.corsiOpen
  }

  over(drop: NgbDropdown) {
    drop.open();
  }
  out(drop: NgbDropdown) {
    drop.close();
  }

  openModal(type: string) {
    const modalRef = this.modalService.open(GenericFormComponent, {
      size: 'lg',
      modalDialogClass: 'signup-modal',
      centered: true,

    });
    modalRef.componentInstance.type = type;
  }

  redirectToApp() {
    console.log('redirect to https://app.easycode.org/');
    window.location.href = 'https://app.easycode.org/';
  }
}
